import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { api, ago } from './api';
const TYPES = {
  discussion: 'Reply in its discussion',
  reply: 'Reply to its post',
  mention: 'Mentioned it'
};

/** Inbox: replies and mentions across all managed accounts (no private messages). attrs: state */
export default class InboxTab extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.f = {
      account: '',
      type: '',
      status: 'pending'
    };
    this.items = null;
    this.busy = {};
    this.instructions = {};
    this.load();
  }
  load() {
    const q = '?status=' + this.f.status + (this.f.account ? '&account=' + this.f.account : '') + (this.f.type ? '&type=' + this.f.type : '');
    return api('GET', '/inbox' + q).then(r => this.items = r.items || []).catch(() => this.items = []).finally(() => m.redraw());
  }
  run(key, p) {
    this.busy[key] = true;
    m.redraw();
    return p.catch(() => {}).finally(() => {
      this.busy[key] = false;
      m.redraw();
    });
  }
  name(id) {
    const a = (this.attrs.state.accounts || []).find(x => x.userId === id);
    return a ? a.displayName : '#' + id;
  }
  view() {
    const sel = (key, options) => m("select", {
      className: "FormControl VEC-inline-select",
      value: this.f[key],
      onchange: e => {
        this.f[key] = e.target.value;
        this.items = null;
        this.load();
      }
    }, options.map(_ref => {
      let [v, l] = _ref;
      return m("option", {
        value: v
      }, l);
    }));
    return m("div", {
      className: "VEC-inbox"
    }, m("div", {
      className: "VEC-row-head"
    }, m("p", {
      className: "VEC-help"
    }, "Replies and mentions from the last 30 days, across every managed account. Posts by other managed accounts aren't included."), m("div", {
      className: "VEC-actions"
    }, sel('account', [['', 'All accounts'], ...(this.attrs.state.accounts || []).map(a => [String(a.userId), a.displayName])]), sel('type', [['', 'All types'], ...Object.keys(TYPES).map(k => [k, TYPES[k]])]), sel('status', [['pending', 'To do'], ['done', 'Done'], ['', 'All']]))), !this.items ? m(LoadingIndicator, null) : this.items.length ? m("ul", {
      className: "VEC-list"
    }, this.items.map(it => {
      const key = it.accountId + ':' + it.postId;
      return m("li", {
        className: "VEC-account",
        key: key
      }, m("div", {
        className: "VEC-inbox-head"
      }, m("span", {
        className: "VEC-pill"
      }, TYPES[it.type]), m("strong", null, this.name(it.accountId)), m("span", {
        className: "VEC-muted"
      }, "\u2190 ", it.author || 'a member', " \xB7 ", ago(it.at)), it.answered ? m("span", {
        className: "VEC-pill is-active"
      }, "Answered") : null), m("a", {
        className: "VEC-sug-title",
        href: '/d/' + it.discussionId + '/' + it.number,
        target: "_blank",
        rel: "noopener"
      }, it.title), m("p", {
        className: "VEC-inbox-text"
      }, it.excerpt), m("div", {
        className: "VEC-actions"
      }, m("input", {
        className: "FormControl VEC-regen-input",
        value: this.instructions[key] || '',
        placeholder: "Angle (optional)",
        oninput: e => this.instructions[key] = e.target.value
      }), m(Button, {
        className: "Button Button--primary",
        icon: "fas fa-magic",
        loading: this.busy['d' + key],
        disabled: !this.attrs.state.aiReady,
        onclick: () => this.draft(it, key)
      }, "Draft a reply"), m(Button, {
        className: "Button",
        loading: this.busy['m' + key],
        onclick: () => this.mark(it, key, it.status === 'done' ? 'pending' : 'done')
      }, it.status === 'done' ? 'Back to to-do' : 'Mark done')));
    })) : m("p", {
      className: "VEC-empty"
    }, "Nothing here."));
  }
  draft(it, key) {
    this.run('d' + key, api('POST', '/drafts', {
      account: it.accountId,
      kind: 'reply',
      generate: true,
      discussion: String(it.discussionId),
      replyToPostId: it.postId,
      instructions: this.instructions[key] || '',
      source: 'inbox',
      sourceRef: it.postId
    }).then(() => {
      app.alerts.show({
        type: 'success'
      }, 'Draft ready for review in Drafts. The item is marked done when the reply is published.');
    }));
  }
  mark(it, key, status) {
    this.run('m' + key, api('POST', '/inbox/mark', {
      account: it.accountId,
      post: it.postId,
      status
    }).then(() => this.load()));
  }
}